import { RootState } from "lib/redux/root/redux.types";

export const selectMedRefill = (state: RootState) => state.medRefill;
